/* -----------------Globals--------------- */
import { useDevice } from "../../../useDevice";

/* -----------------UI--------------- */
import { Surface } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../../useAppTheme";

/* -----------------Props--------------- */
type Props = {
	children: React.ReactNode;
	isSummativeTest?: boolean;
};
/* -----------------Component--------------- */
const BottomNavigationSession = (props: Props) => {
	const { children, isSummativeTest } = props;
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const insets = useSafeAreaInsets();
	const insetBottom = Math.max(insets.bottom - 16, 0);
	const defaultHeight = 80;

	// TODO: Instead of absolute position, this should be outside of the ScrollView
	return (
		<Surface
			style={{
				elevation: isSummativeTest ? 0 : 4,
				borderTopWidth: isSummativeTest ? 1 : 0,
				borderTopColor: isSummativeTest ? theme.colors.divider : undefined,
				height:
					defaultHeight + insetBottom + (isMobile || isSummativeTest ? 0 : 16),
				display: "flex",
				flexDirection: "row",
				alignItems: isMobile ? "flex-start" : "center",
				paddingHorizontal: 16,
				paddingTop: isMobile ? 16 : 0,
				position: "absolute",
				bottom: 0,
				right: 0,
				left: 0,
				backgroundColor: isSummativeTest
					? theme.colors.surface
					: theme.colors.elevation.level1,
			}}
		>
			{children}
		</Surface>
	);
};

export default BottomNavigationSession;
